"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameSteamDataSupportInfoToJSON = exports.OWGameSteamDataSupportInfoFromJSONTyped = exports.OWGameSteamDataSupportInfoFromJSON = void 0;
var runtime_1 = require("../runtime");
function OWGameSteamDataSupportInfoFromJSON(json) {
    return OWGameSteamDataSupportInfoFromJSONTyped(json, false);
}
exports.OWGameSteamDataSupportInfoFromJSON = OWGameSteamDataSupportInfoFromJSON;
function OWGameSteamDataSupportInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
    };
}
exports.OWGameSteamDataSupportInfoFromJSONTyped = OWGameSteamDataSupportInfoFromJSONTyped;
function OWGameSteamDataSupportInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'email': value.email,
    };
}
exports.OWGameSteamDataSupportInfoToJSON = OWGameSteamDataSupportInfoToJSON;
